module.exports = __webpack_public_path__ + "static/category-banner-3595bf4f2c5c1d41039a31d9e462bdeb.png";